// extracted by mini-css-extract-plugin
export default {"table":"styles_table__f5mX2","no-header":"styles_no-header__6zd1I","dateCell":"styles_dateCell__Qvz9R","multipleRecordsIconContainer":"styles_multipleRecordsIconContainer__bHKrt"};